import * as React from 'react';
import { ConfigurationModel, ConfigurationDefaultModel } from 'franke-trough-dependencies';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { RequestApiResult } from 'loopback-react-request';

import './TroughMinValues.scss';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './TroughMinValues.messages';

export interface TroughMinValuesProps {
  configuration: RequestApiResult<ConfigurationModel>;
}

export class TroughMinValuesPartial extends React.Component<TroughMinValuesProps> {
  public render() {
    const washBasin = this.defaults && this.defaults.washBasinDimension;
    return (
      <div className="trough-min-values-partial col-12">
        {washBasin && (
          <div className="trough-min-values-inner border-bottom">
            <div className="trough-min-values-tooltip p-4">
              <h6><small className="font-weight-bold"><FormattedMessage {...MESSAGES.troughListMinValuesText} /></small></h6>
              <p className="m-0 font-weight-bold">{washBasin.plateWidth.values.min} x {washBasin.plateDepth.default} mm</p>
            </div>
          </div>  
        )}
      </div>
    );
  }

  private get configuration(): ConfigurationModel | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result;
  }

  private get defaults(): ConfigurationDefaultModel | undefined {
    return this.configuration && this.configuration.defaults;
  }
}

export const TroughMinValues = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(TroughMinValuesPartial);

export default TroughMinValues;